const rankingData = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子，酒店同框照曝光引热议', heat: '9.8万', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '知名网红直播带货翻车，产品涉嫌虚假宣传被立案调查', heat: '8.6万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '某女星离婚内幕被扒，知情人曝其净身出户另有隐情', heat: '7.9万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 4, title: '综艺节目录制现场发生冲突，两位嘉宾激烈互怼全程', heat: '6.5万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '某选秀出道偶像被曝私联粉丝，聊天记录流出引争议', heat: '5.2万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 6, title: '娱乐圈年度最离谱合约曝光，艺人分成比例低至1:9', heat: '4.8万', tag: '', tagColor: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热搜榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            实时聚合全网热议话题，每分钟更新热度排行，不错过任何一个大瓜
          </p>
        </div>

        <div className="space-y-3">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-100 rounded-xl hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-9 h-9 md:w-10 md:h-10 rounded-lg flex items-center justify-center font-heading text-lg font-bold ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base text-foreground-900 font-medium truncate group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>

              <div className="flex-shrink-0 flex items-center gap-2">
                {item.tag && (
                  <span className={`px-2 py-0.5 rounded text-xs font-medium text-background-50 ${item.tagColor}`}>
                    {item.tag}
                  </span>
                )}
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}